import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/hooks/useData";
import { imgUrl } from "@/lib/api";

export const About = () => {
  const { content } = useContent();
  const c = content.about;
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-32" data-testid="about-section" id="about">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1 grid grid-cols-2 gap-4">
          <Reveal className="img-frame group aspect-[3/4] mt-10">
            <img src={imgUrl(c.image1)} alt="Interior" className="w-full h-full object-cover" />
          </Reveal>
          <Reveal delay={0.15} className="img-frame group aspect-[3/4]">
            <img src={imgUrl(c.image2)} alt="Custom cabinetry" className="w-full h-full object-cover" />
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2">
          <Eyebrow>{c.eyebrow}</Eyebrow>
          <Reveal>
            <h2 className="font-display text-4xl sm:text-5xl font-medium leading-[1.08] tracking-tight text-[#2C2A29] mt-4">
              {c.title} <span className="italic text-[#9E8773]">{c.accent}</span>{c.title_suffix}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg text-[#5E5A54] font-light leading-relaxed">{c.paragraph1}</p>
            <p className="mt-4 text-lg text-[#5E5A54] font-light leading-relaxed">{c.paragraph2}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <Link to="/about" className="inline-flex items-center gap-2 mt-8 label-eyebrow text-[11px] text-[#2C2A29] border-b border-[#2C2A29] pb-1 hover:text-[#9E8773] hover:border-[#9E8773] transition-colors group" data-testid="about-readmore">
              {c.cta_label}
              <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
